import React, { useState, useEffect, useCallback } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TextArea from '../UI/TextArea';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import AlertMessage from '../AlertMessage';
import { bannerDashboardPut } from '../../api';
import Loading from 'components/Loading';
import { messageSentNotice } from '../UI/Notifications';
import { bannerDashboardGet } from '../../api';
import { useHistory } from "react-router-dom";

const UpdateDashboardMessage = () => {
  const { register, handleSubmit, errors } = useForm();
  const [inputValue, setInputValue] = useState();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  let history = useHistory();

  const ALERT_MESSAGE_PREVIEW = `
  <div>
    <h6 class="mb-0">Message Preview</h6>
    <p class="mb-0">
      ${message ?? ''}
    </p>
  </div> 
`;

  const onChangeHandler = (value) => {
    setInputValue(value.value)
  }

  const onSubmit = data => {
    setLoading(true)
    bannerDashboardPut(data)
    .then(response => {
      setLoading(false)
      setMessage(data.body);
      messageSentNotice("Success");
      setInputValue('');
    })
    .catch(error => {
      console.log(error);
    })
  }

  const handleEsc = useCallback((e) => {
    if(e.keyCode === 27) {
    history.goBack();
    }
  }, []);


  useEffect(() => {
    setLoading(true); 
    bannerDashboardGet({})
    .then(response => {
        setMessage(response.data.body) // response data type
        setLoading(false); 
    }).catch(error => {
        console.log(error)
        setLoading(false); 
    })
  }, [message]);

  useEffect(() => {
    document.addEventListener("keydown", handleEsc, false);

    return () => {
      document.removeEventListener("keydown", handleEsc, false);
    };
  }, []);

  return (
    <>
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5 text-center">
              Dashboard message to all users
            </h3>
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            { message &&
              <AlertMessage 
                alertMessage={ALERT_MESSAGE_PREVIEW}
                spaces="mt-0 mb-5"
              />
            }
          </Col>
        </Row>
        <Row>
          <Col lg={{ span: 10, offset: 1 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <fieldset>
                <label htmlFor="body">Update the admin dashboard message by utilizing the form below</label>
                <TextArea 
                  name="body" 
                  register={register()}
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                />
              </fieldset>
              <div className="d-flex align-items-center">
                <button
                  className="btnSizes filledBtn"
                  type="submit"
                >
                  Update Message
                </button>
                <a 
                  className="btnSizes transparentBtn border-0 ml-5" 
                  onClick={() => history.goBack()} 
                >
                  Cancel
                </a>
              </div>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
    { loading && <Loading />}
    </>  
  )
}

export default UpdateDashboardMessage;